import React from 'react';

// local dependencies
import { widgetError as WidgetError } from 'ui/views/widgets/widgetError';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {function}
 * @desc This Higher-Order-Component displays preloader view, error view and real widget view based on the state of the network.
 * @param {object} Component - A React component
 * @example
 * import { withNetworkState } from 'ui/hoc/withNetworkState';
 *
 * // create a component
 * const ComponentWithHOC = WithNetworkState( PreloaderView, SuccessView, ErrorView = WidgetError );
 * @return {class} - A standard React component
 */
const withNetworkState = ( PreloaderView, SuccessView, ErrorView = WidgetError ) => {
    class WithNetworkState extends React.Component {
        constructor( props ) {
            super( props );
        }

        render() {

            // extract props
            const { isFetching, networkStatus, networkError, errorViewConfig, ...restProps } = this.props;

            if( isFetching ) {
                return (
                    <PreloaderView
                        { ...restProps }
                    />
                );
            } else if( networkStatus !== SERVICE_RESPONSE_STATUS.SUCCESS ) {
                return (
                    <ErrorView
                        networkError={ networkError }
                        errorViewConfig={ errorViewConfig }
                        { ...restProps }
                    />
                );
            } else {
                return (
                    <SuccessView
                        { ...restProps }
                    />
                );
            }
        }
    }

    // set display name
    WithNetworkState.displayName = 'WithNetworkState';

    // set default props
    WithNetworkState.defaultProps = {
        isFetching: false,
        networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
    };

    // return class
    return WithNetworkState;
};

export { withNetworkState };
